import mime from 'mime';
import { saveAs } from 'file-saver';

export const addExtensionToBase64File = (base64: string, name: string) => {
  const mimeType = base64.substring('data:'.length, base64.indexOf(';base64'));
  const ext = mime.getExtension(mimeType) || null;
  return ext ? `${name}.${ext}` : name;
};

export const saveFileFromResponse = async (response: Response, filename: string) => {
  const blob = await response.blob();
  const newBlob = new Blob([blob]);
  saveAs(newBlob, filename);
};
